import { Input } from "simplydo/react/component-library";

import { FieldProps } from "./FieldProps";

const ShortText = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FieldProps) => {
  if (!isEditing) return <span>{fieldValue}</span>;
  return (
    <div>
      <Input
        fluid
        value={fieldValue}
        onChange={(e) => updateIdea(e.target.value, ["templated", field.id])}
        readOnly={!isEditing}
      />
    </div>
  );
};

export default ShortText;
